import { MaintenanceTaskActions } from "routes/component-library/explorer/component-library-slot-definitions"
import { ComponentLibraryFindSimilarButton } from "./component-library-find-similar-button"

MaintenanceTaskActions.plug(<ComponentLibraryFindSimilarButton if={isEmbedded} />)

function isEmbedded({ embedded }) {
    return !!embedded
}
